import { render } from "./MarkdownText.vue?vue&type=template&id=74b6a116"
import script from "./MarkdownText.vue?vue&type=script&lang=js"
export * from "./MarkdownText.vue?vue&type=script&lang=js"

import "./MarkdownText.vue?vue&type=style&index=0&id=74b6a116&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__